module.exports = __webpack_public_path__ + "img/editProfile.9f934d72.svg";